import React from "react";
import { RCCSelect } from "react-common-components";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import { useTranslation } from "src/context/Translations/context";

const Select: React.FC<IComponentSelect> = ({...rest}) => {
	const { translate } = useTranslation();
	return <RCCSelect
		placeholder={`${translate("Selecione")}...`}
		{...rest}
	/>;
};

export default Select;
